'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrap = require('./bootstrap');

var fullpage = {
  init: _bootstrap.bootstrap,
  scrollPage: _bootstrap.page.scrollPage,
  scrollSlide: _bootstrap.page.scrollSlide,
  moveTo: _bootstrap.page.moveTo,
  moveToNext: _bootstrap.page.move.next,
  moveToPre: _bootstrap.page.move.pre,
  slideToNext: _bootstrap.page.slide.next,
  slideToPre: _bootstrap.page.slide.pre
};

(function (global) {
  global.fullpage = fullpage;
})(window);

exports.default = fullpage;




//////////////////
// WEBPACK FOOTER
// ./~/notone/index.js
// module id = 628
// module chunks = 2